import { Injectable } from '@angular/core';
import {AppPageConfig,Data} from '../model/xmlconfig/app.page.config';
import {AppPageElement as AppPageTemplateElement } from '../model/xmlconfig/app.page.element';
import {AppSelectItems} from '../model/xmlconfig/app.select.items';
import { SysAccount} from '../model/sys.account';
import {AppPageTemplateConotent} from '../model/xmlconfig/app.page.template.content';
import {SysMenus as AppMenus, SysMenus} from '../model/sys.menus';
import {SysToken as  Token} from '../model/sys.token';
import {ActivatedRoute,Router} from '@angular/router';
import { AlertController, NavController,Platform,ToastController} from '@ionic/angular';
import { Buffer } from 'buffer';
import {BaseModal} from '../model/base';
import { PlatformLocation} from '@angular/common';
import {MessageclientService} from '../service/messageclient.service';
import { Device } from '@ionic-native/device/ngx';
import {File} from '@ionic-native/file/ngx';
import { WebParameterContext, WebResponesContext } from 'src/model/common';
import { AgentConfigParams } from 'src/model/sys.params';
// import { resolve } from 'dns';
// import { HttpClient } from '@angular/common/http';
// import { HttpCustomerService } from './httpcustomer.service';
// import { rejects } from 'assert';

declare var cordova:any;
declare var app;
declare var wx:any;//启用微信客户端
@Injectable({
  providedIn: 'root'
})
/**公共实体类 */
export class CommonService {

  constructor(
    private active:ActivatedRoute,
    private base:BaseModal,
    private router:Router,
    private navctr:NavController,
    private alertCon:AlertController,
    private msg:MessageclientService,
    private platformlocation:PlatformLocation,
    private platform:Platform,
    // private http: HttpCustomerService,
    private file:File,
    private device:Device,
    private toastController:ToastController
  ) { }

    /**
 * 判断是否是android平台
 */
get isAndroid(): boolean {
  return this.platform.is("cordova") && this.platform.is("android");
}

/**
 * 是否ios真机环境
 * @return {boolean}
 */
get isIos(): boolean {
  return this.platform.is("cordova") && (this.platform.is('ios') || this.platform.is('ipad') || this.platform.is('iphone'));
}
  numberAddZore(num: Number):string{
    return num < 10 ? '0' +num : '' + num;
  }
  /**
   * 加密方法（base64位加密）
   *@param encodeStr 加密字符串
   */
  encodeBase64( encodeStr: string ): string {
    return new Buffer( encodeStr ).toString( 'base64' );
  }
  /**
   * 解密方法（只能处理64为密文）
   * @param decodeStr 加密密文
   */
  decodeBase64( decodeStr: string ): string {
    return new Buffer( decodeStr, 'base64' ).toString();
  }
/**
 * 封装时间段查询
 * @param startDate 开始日期
 * @param endDate 结束日期
 */
  BetweenDate(startDate,endDate){
    let obj={
      "BeforeValue": startDate,
      "EndValue": endDate,
      "Type": "Between"
    };
    return obj;
  }
  /**需要模糊查询的值 */
  LikeSearch(value:any){
    return {
      "Value":value,
      "LikeType":"Middle",
      "Type":"Like"
    }
  }
  /**
   * 获取当前时间包含年月日
   */
 get getNowdate(){
    let date:Date = new Date();
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any = date.getDate();
   month=tmp1;
   day = tmp2;
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2<10){
    day = "0"+tmp2;
   }
   year = riqi;
    return year+"-"+month+"-"+day+" "+date.getHours()+":"+date.getMinutes()+":"+date.getSeconds();
  }
  /**
   * 获取当前时间不包含时分秒
   */
 get getNow(){
    let date:Date = new Date();
    // ////console.log(1001011);
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any =  date.getDate();
   month=tmp1;
   day = tmp2;
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2 <10){
    day = "0"+tmp2;
   }
   year = riqi;
    return year+"-"+month+"-"+day;
  }
    /**
   * 获取当前时间不包含时分秒并且小于10不会添加零
   */
 get getNows(){
  let date:Date = new Date();
  // ////console.log(1001011);
  let year,month,day;
 let arrayday = date.toLocaleDateString().split("/");
 let riqi = date.getFullYear();
 let tmp1:any = date.getMonth()+1;
 let tmp2:any =  date.getDate();
 month=tmp1;
 day = tmp2;
 year = riqi;
  return year+"-"+month+"-"+day;
}
  /**
   * 获取当前时间,yyyymmddHHmmss
   */
  get getNowDatetime(){
    let date:Date = new Date();
    console.log(date,"年月日");
    let year,month,day;
   let arrayday = date.toLocaleDateString().split("/");
   let riqi = date.getFullYear();
   let tmp1:any = date.getMonth()+1;
   let tmp2:any =  date.getDate();
   month=tmp1;
   day = tmp2;
   if(tmp1 <10){
    month = "0"+tmp1;
   }
   if(tmp2<10){
    day = "0"+tmp2;
   }
   year = riqi;
   let str:string = year.toString()+month.toString()+day.toString()+date.getHours().toString()+date.getMinutes().toString()+date.getSeconds().toString();
   console.log(str);
    return str;
  }
  /**
   * token超时
   */
  loginTimeOut(){
    const that = this;
    localStorage.removeItem("tokentimeOut");
    let expiresIn:number = Number(that.getToken.ExpiresIn);//that.getToken.ExpiresIn;
    ////console.log("token过期时间:"+expiresIn);
    let y:number = 0;
  let timeout = setInterval(function(){
    // //console.log(y);
    if(!that.GetAccount.IsLogin){
      clearInterval(timeout);
      localStorage.removeItem("tokentimeOut");
      y = 0;
    }
    if(y == expiresIn){
      clearInterval(timeout);
      y = 0;
      localStorage.setItem("tokentimeOut","true");
      }
      y++;
    },1000);
  }
  /**
   * 算出服务器和本地时间差
   */
  getOutnumber(){
    let token = this.getToken;
    if(token){
      let encodetoken = new Buffer(token.AccessToken.split('.')[1], 'base64').toString();
      let tokenData = JSON.parse(encodetoken);
      let Nowtimestamp = Math.round(new Date().getTime() / 1000);//获取当前时间的时间戳
        let timedifference =  tokenData.nbf - Nowtimestamp;//保证本地时间与服务器同步
      localStorage.setItem("exp",tokenData.exp);//过期时间戳
      localStorage.setItem("timediffer",timedifference.toString());//误差时间戳
    }
       // //console.log(tokenData.);
  }

  /**
   * 
   * @param url 跳转地址
   * @param title 页面标题
   */
  goWebPage(url:string,title:string) {
    this.router.navigate(['/webpage', { url: url, name: title}])
  }
  /**
   * 计算倒计时
   */
 GetTimeOut():Promise<any>{
  let that = this;
  return new Promise<any>((resolve,reject)=>{
    if( that.base.Minute<=0){
      reject(false);
    }else{//倒计时启动时
      let icountTime=setInterval(()=>{
        let obj={};
          obj["check"]=false;
          obj["inter"]=icountTime;
        if(!that.base.InterVal){
          resolve(obj);
        }else{
      // //console.log(that.base.Second);
      if(that.base.Second<10){
        //如果秒数少于10在前面加上0
        that.base.timeOut =  that.base.Minute+":0"+that.base.Second;
                }else{
         that.base.timeOut =  that.base.Minute+":"+that.base.Second;
                }
                that.base.Second--;
                if(that.base.Second<0){
                   that.base.Minute--;
                   if(that.base.Minute<=0){
                    obj["check"]=true;
                    obj["inter"]=icountTime;
                    resolve(obj);
                   }
                    //如果秒数少于0就变成59秒
                    that.base.Second=59;
          }
        }
       },1000);
    }

  });
 }
  /**
   * 存储登录信息数据
   * @param obj 需要存储的对象名称
   */
  // SaveStorage(obj:WebResponesContext):void{
    SaveStorage(obj:any):void{
      const that =this;
    if(obj){
      //存储用户信息
      if(obj.Account){
        obj.Account.IsLogin=true;
        localStorage.setItem("account",JSON.stringify(obj.Account));
      }
      //存取菜单权限
      if(obj.Status.AppMenus){
        if(obj.Status.AppMenus.length>0){
          let arrayMenus=this.GetMenusDataList(obj.Status.AppMenus);
          // localStorage.setItem("menus",JSON.stringify(obj.Account.AppMenus));//存储菜单信息
          localStorage.setItem("menus",JSON.stringify(arrayMenus||[]));//存储菜单信息
        }
      }
      //如果后端xml修改后更新本地json文件
      if(obj.Status.AppPageConfig){
        const pagesData:Array<AppPageConfig>=obj.Status.AppPageConfig.pages;//获取修改过的xml文件
        let oldPagesData:Array<AppPageConfig>=that.GetStorageKey("pageConfig")||[];//获取所有xml文件
        if(pagesData.length>0){
          pagesData.forEach((pages,index)=>{
           let findIndex=oldPagesData.findIndex(ut=>ut.Key.trim().toLowerCase()===pages.Key.trim().toLowerCase());
           if(findIndex>=0){
             console.log("更新文件xml pages",pages);
            console.log("更新文件 oldPagesData[findIndex].Data sss",oldPagesData[findIndex].Data);
            oldPagesData[findIndex].Data=pages.Data;
            console.log("更新文件 oldPagesData[findIndex].Data eee",oldPagesData[findIndex].Data);

           }else{
            oldPagesData.push(pages);//如果新增xml文件则直接添加进去。
           }
          });
          localStorage.setItem("pageConfig",JSON.stringify(oldPagesData));
           //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
           try{
            this.WriteExistingFile(JSON.stringify(oldPagesData)).then(result=>{
              console.log(result);
            }).catch(error=>{
              console.error(error,"保存缓存文件到手机安装目录中");
            });
           }catch(err){
            console.error(err,"保存缓存文件到手机安装目录中try");
           }
          //#endregion
        }
        localStorage.setItem("pageConfigTime",obj.Status.AppPageConfig.Stamp|| 0);//缓存当前页面时间戳

      }
      //缓存Token
      if(obj.Status.Token){
        localStorage.setItem("token",JSON.stringify(obj.Status.Token));
      //  this.getOutnumber();
      }

      //模块权限
      if(obj.Status.PageMode){
        // //console.log("PageMode");
        if(Object.keys(obj.Status.PageMode).length>0){
          let oldTempPage:any = obj.Status.PageMode;
          if(this.GetStorageKey("pagemode")){
           let  TempPage=this.GetStorageKey("pagemode");
           //判断主文件下是否存在xml节点。存在就更新,不存在就添加到pageConfig节点下
          //  if(this.GetStorageKey("pageConfig")){
          //    let pageConfigWebTemp = this.GetStorageKey("pageConfig");
          //    TempPage.forEach((tp,tindex)=>{
          //      let tempif:boolean = false;//判断是否找到匹配的项目
          //     pageConfigWebTemp.forEach((pageconfig,webindex)=>{
          //       if(tp.pagename==pageconfig.Key){
          //         tempif=true;
          //         pageconfig[webindex].Data=tp.page;
          //       }
          //     });
          //     if(!tempif){
          //       let _tpobj={Key:tp.pagename,Data:[]};
          //        _tpobj["Data"]=tp.page;
          //        pageConfigWebTemp.push(_tpobj);
          //     }
          //    });
          //  }
            oldTempPage = Object.assign(oldTempPage,TempPage);
          }
          localStorage.setItem("pagemode",JSON.stringify(oldTempPage));
        }
      }
      //数据权限
      if(obj.Status.PageFieldPermission){
        if(Object.keys(obj.Status.PageFieldPermission).length>0){
          localStorage.setItem("fieldpermission",JSON.stringify(obj.Status.PageFieldPermission));
        }
      }
      //采集点
      if(obj.Status.TempPage){
        if(Object.keys(obj.Status.TempPage).length>0){
          let oldArray:Array<any> = obj.Status.TempPage;

          if(this.GetStorageKey("temppage")){
             oldArray=this.GetStorageKey("temppage");
            obj.Status.TempPage.forEach((newtempage,index)=>{
              let findIndex=oldArray.findIndex(ut=>ut.pagename.trim().toLowerCase()===newtempage.pagename.trim().toLowerCase());
              if(findIndex>=0){
                oldArray[index]=newtempage;
              }else{
                oldArray.push(newtempage);
              }
            });
          }
          localStorage.setItem("temppage",JSON.stringify(oldArray));
        }
      }
      //判断是否PG是否排班
      if(obj.Status.Info){
        if(obj.Status.Info.SN){
          localStorage.setItem("tbstore", JSON.stringify({"ID":obj.Status.Info.SN.a_FK_Store_ID}));
          localStorage.setItem("pginfo",JSON.stringify(obj.Status.Info.SN))
       }
      }
    }
  }
  /**
   * 过滤当前页面，以及数据权限
   * @param allPageModel 系统xml
   * @param configName 当前页面名称
   */
  private PageModalOrPermission(allPageModel:Data,configName?:string):Data{
  const that=this;
   let fieldPage:Data= that.GetFieldPageConfig(configName);//获取当前页面配置数据
   if(fieldPage){
     //判断首节菜单是否有权限
     let head="";
     if(fieldPage.head){
      head=fieldPage.head.name||"";
     }
   if(head!=""){
    delete allPageModel.head;
  }else{
    if(fieldPage.head){
      if(fieldPage.head.element.length>0){
        fieldPage.head.element.forEach((element,index)=>{
         let head_element=element||"";
        if(head_element!=""){
         allPageModel.head.element.splice(index,1);
        }
        });
      }
    }
  }
  
  //判断内容块是否有权限
  if(fieldPage.template.length>0){//判断当前页面是否有模块template
   fieldPage.template.forEach((item,tindex)=>{
    let j=allPageModel.template.length;
    while(j--){
      if(allPageModel.template[j].name.trim().toLowerCase()===item.name.toString().toLowerCase()){
        if(!item.head && !item.content){
          allPageModel.template.splice(j,1);
         }
         if(item.head){
          if(item.head.name){
            delete allPageModel.template[j].head;
          }else{
            if(item.head.element.length>0){//判断头部模块下的element是否有权限
              item.head.element.forEach(heade=>{
                let hi=allPageModel.template[j].content.element.length;
                while(hi--){
                  if(allPageModel.template[j].head.element[hi].name.toString().trim().toLowerCase()==heade.toString().trim().toLowerCase()){
                    allPageModel.template[j].head.element.splice(hi,1);
                  }
                }
              });
              // allPageModel.template[tindex].head.element=this.ElementFilter(item.head.element,tindex,allPageModel.template[tindex].head.element);
            }
          }
         }
         if(item.content){//content模块存在.如果 content Name属性存在，就判断无权限,直接删除,如果content节点存在,element节点也存在需要遍历删除
          if(item.content.name){
           delete allPageModel.template[tindex].content;
         }else{
               if(item.content.element.length>0){
                item.content.element.forEach(ele=>{
                  let ci=allPageModel.template[j].content.element.length;
                  while(ci--){
                    if(allPageModel.template[j].content.element[ci].name.toString().trim().toLowerCase()==ele.toString().trim().toLowerCase()){
                      allPageModel.template[j].content.element.splice(ci,1);
                    }
                  }
                });
                //  allPageModel.template[tindex].content.element=this.ElementFilter(item.content.element,tindex,allPageModel.template[tindex].content.element,item.content.configName);
               }
             }
        }
      }
     }
   });
  }
  }
  //处理当前页面的字段权限过滤
  if(allPageModel.head)
  {
    allPageModel.head.element.forEach((tes,tindex)=>{
      if(tes.selectItemList.gridViewConfigName){
        allPageModel.head.element[tindex].selectItemList.selectItem=this.SelectItemsFilter(tes.selectItemList.selectItem,tes.selectItemList.gridViewConfigName);
      }
    });
  }
  if(allPageModel.template.length>0){
    allPageModel.template.forEach((temp,indexs)=>{
      //头部节点
      if(temp.head){
        if(temp.head.element.length>0){
          temp.head.element.forEach((hitem,hindex)=>{
            if(hitem.selectItemList.gridViewConfigName){
              allPageModel.template[indexs].head.element[hindex].selectItemList.selectItem=this.SelectItemsFilter(hitem.selectItemList.selectItem,hitem.selectItemList.gridViewConfigName);
            }
          });
        }
      }
      //内容块节点
     
      if(temp.content){
        if(temp.content.element.length>0){
          if(temp.content.configName){
            allPageModel.template[indexs].content=this.ContentPersionFilter(allPageModel.template[indexs].content,temp.content.configName.trim());
          }
          temp.content.element.forEach((eitem,eindex)=>{
            if(eitem.selectItemList.gridViewConfigName){
              allPageModel.template[indexs].content.element[eindex].selectItemList.selectItem=this.SelectItemsFilter(eitem.selectItemList.selectItem,eitem.selectItemList.gridViewConfigName);
            }
            });
        }
      }
      });
  }
  return allPageModel;
  }
  /**
   * 过滤页面中Element没有权限的节点；
   * @param _element 当前页面Element节点
   * @param index 当前节索引
   * @param All 本地数据对应的节点Element
   * @param configName 判断父级是否有ConfigName
   */
  private ElementFilter(_element:Array<AppPageTemplateElement>,index:number,AllEle:Array<AppPageTemplateElement>,configName:string=null):Array<AppPageTemplateElement>
  {
    ////console.log(8008088);
    //先判断是否有权限菜单权限，过滤掉没有权限的Element
    _element.forEach((Nitem,Nindex)=>{
      let c_E:any=Nitem||"";//节点没有权限时，处理本地缓存中对应的节点
        if(c_E.trim()!=""){
          let j=AllEle.length;
          while(j--){
               if(AllEle[j].name.trim().toLowerCase()===c_E.toString().toLowerCase()){
                AllEle.splice(j,1);
               }
          }
        }
    });
    //如果Content节点上存在ConfigName时过滤字段权限
    if(configName && configName!=""){
      const filterE=this.GetStorageKey("fieldpermission")||{};//获取字段权限
      let k=AllEle.length;
      while(k--){
        let itemkey=filterE[configName];
        if(itemkey){
          const ekey= itemkey[configName][AllEle[k].field];
          if(typeof(ekey)!="undefined"){
            if(ekey===0){//表示不可见状态
              AllEle.splice(k,1);
            }else if(ekey===2){//表示只读状态
              AllEle[k].readonly=true;
            }
          }

        }
      }
    }
  return AllEle;
  }
/**
 * 过滤content存在ConfigName时的字段权限；
 * @param AllEle 获取对应的Content节点
 * @param configName 当前的xml名称
 */
  ContentPersionFilter(AllEle:AppPageTemplateConotent,configName:string=null):AppPageTemplateConotent{
    const filterE=this.GetStorageKey("fieldpermission")||{};//获取字段权限
    let k=AllEle.element.length;
    while(k--){
      let itemkey=filterE[configName];
      if(itemkey){
        const ekey= itemkey[AllEle.element[k].name];
        if(typeof(ekey)!="undefined"){
          if(ekey===0){//表示不可见状态
            AllEle.element.splice(k,1);
          }else if(ekey===2){//表示只读状态
            AllEle.element[k].readonly=true;
          }
        }
      }
    }
    return AllEle;
  }
  /**
   * element节点下selectItem节点字段权限
   * @param selectItem  当前xml selectItem节点
   * @param ConfigName  当前Element节点 ConfigName属性值
   */
  private SelectItemsFilter(selectItem:Array<AppSelectItems>,ConfigName:string){
   const filterE=this.GetStorageKey("fieldpermission")||{};//获取字段权限
  //  let newArrayItem:Array<AppPageTemplateSelectItem>=new Array<AppPageTemplateSelectItem>();
   if(filterE[ConfigName]){
     const len=selectItem.length-1;
     for(let t=len;t>=0;t--){
      const pkey= filterE[ConfigName][selectItem[t].field];
      if(typeof(pkey)!="undefined"){
        if(pkey===0){
          selectItem.splice(t,1);
        }else if(pkey===2){
          selectItem[t].readonly=true;
        }
      }
     }
   }
   return selectItem;

  }
  /**
   * 遍历菜单,把一次菜单但不是首页的放入其他一次菜单中
   * @param _menus 菜单对象
   */
  private GetMenusDataList(_menus:Array<any>){
    let meus_False:Array<any>=new Array<any>();
    let arrayList:Array<any>=new Array<any>();
    _menus.forEach((items,index)=>{
      if(items.IsHome===false){
        meus_False.push(items);
      }
    });
    _menus.forEach((items,index)=>{
      if(items.IsHome===true){
        if(typeof(items.menus)!="undefined"){
            meus_False.forEach((its,index)=>{
            items.menus.push(its);
          });
        }
        arrayList.push(items);
      }
    });
    return arrayList;
  }
  /**
   * 获取当前存储的用户信息数据，如key为"account","menus","pageConfig","token";
   * @param obj 对应的key值
   */
  GetStorageKey(obj:string):any{
    let body:JSON=null;
    if(obj){
      let Datakey=localStorage.getItem(obj);
      if(Datakey){
        body=JSON.parse(Datakey);
      }
    }
    return body;
  }
  /**
   * 移除当前缓存数据
   * @param obj 对应的key值
   */
  RemoveStorageKey(obj:string):boolean{
    let istrue:boolean=false;
    if(obj){
      if(this.GetStorageKey(obj)){
        istrue=true;
        localStorage.removeItem(obj);
      }
    }
    return istrue;
  }
  /**
   * 清空当前缓存数据
   */
  removeAllStorage(){
    localStorage.clear();
  }
  /**
   * 获取登录消息
   */
 get GetAccount():SysAccount{
    let account:SysAccount = new SysAccount();
    if(this.GetStorageKey("account")){
      account = this.GetStorageKey("account");
    }
    return account;
  }
  /**
   * 角色code返回
   */
  get GetRoleSFA(){
    const that = this;
     let Roname:string= null;
     if(that.GetAccount.Roles){
      if(that.GetAccount.Roles.length>0){
        Roname = that.GetAccount.Roles[0].RoleName;
       }
       that.GetAccount.Roles.forEach(items=>{
         if(items.Code){
           if(items.Code.toLocaleLowerCase().toString()=="1001" ||items.Code.toLocaleLowerCase().toString()=="1004" ||items.Code.toLocaleLowerCase().toString()=="1003" ||items.Code.toLocaleLowerCase().toString()=="1002" ){
            Roname =  items.RoleName;
           }
         }
       });
     }
    return Roname;
  }
  /**
   * 用户退出登录
   */
  public LoginOut(msg:string="确定注销当前帐号吗？"){
    let that=this;
    that.msg.Confirm(msg).then(data=>{
      if(data){
        let newremove:Array<string>=new Array<string>();
            newremove.push("token");
            newremove.push("pginfo");
            newremove.push("tbstore");
            newremove.push("setMap");
            newremove.push("pgindata");
            newremove.push("pgondate");
            newremove.push("startDate");
            newremove.push("enddate");
            newremove.push("clock");
            newremove.push("clockOut");
            newremove.push("backurl");
            newremove.push("exp");
            newremove.push("menus");
            newremove.push("readCount");
            newremove.push("timediffer");
            newremove.push("ISCLOSE");
            newremove.push("INFO");
            newremove.push("loginError");
            newremove.push("INFOBAGE");
            newremove.push("badge_"+that.GetAccount.Id);
        that.removeItem(newremove);
        sessionStorage.clear();
        // //console.log(data);
        let out:SysAccount=new SysAccount();
          that.base.account = out;
          that.base.subMenus=[];
          localStorage.setItem("account",JSON.stringify(out));
         that.href('/login');
        // that.router.navigate(['/login'],{replaceUrl:true});
      }
    })
  }
  /**
   * token过期
   */
  public LoginOutToken(){
    let that=this;
    let out:SysAccount=new SysAccount();
    that.base.account = out;
    that.base.subMenus=[];
    localStorage.setItem("account",JSON.stringify(out));
  //  that.href('/login',true);
  this.router.navigate(['/login'], { replaceUrl: true });
  }
  /**
   * 页面跳转连接
   * @param url 需要跳转的url
   * @param isRefresh 是否刷新页面，针对返回上一页时处理
   */
  public href(url:string,isRefresh:boolean=false){
    ////console.log(url);
    let urlArray:Array<string>=new Array<string>();
        urlArray.push(url);
   return this.router.navigate(urlArray,{replaceUrl:isRefresh});
  }
  /**
   * 获取一级菜单
   * @param url 
   */
  public getFirstMenuUrl(url:string):boolean{
    let meunsUrl:boolean=false;
    ////console.log("menus");
     //获取一级菜单的url地址
     this.GetMenus.forEach((menus)=>{
       if(this.getUrlList(url,menus.Component)){
        meunsUrl=true;
       }
      // if(menus.Url.trim().toLowerCase()===url.replace('/tabs/','').trim().toLowerCase()){
      //     meunsUrl=true;
      // }
      });
    return meunsUrl;
  }
  /**
   * 获取是否第一级菜单
   * @param url 获取当前的url地址
   * @param menuUrl 数据库返回的url地址
   */
  public getUrlList(url,menuUrl:string):boolean{
     let _urlsplit=url.split('/');
     let homeurl = false;
     _urlsplit.forEach((items,index)=>{
         if(items.toLowerCase()==menuUrl.toLowerCase()){
          homeurl = true;
         }
     });
    //  for(let i =0; i> url.length; i++){
    //    if(menuUrl.toLowerCase()==url[i])
    //    {
    //     homeurl = true;
    //    }
    //  }
     return homeurl;
  }

  /**
   * 获取选中的一级菜单
   * @param url 
   */
  public getMenuAction(url:string):number{
    let meunsAct: number;
     //获取一级菜单的url地址
     this.GetMenus.forEach((menus,index)=>{
      if(url.replace('/tabs/','').trim().toLowerCase().indexOf(menus.Url.trim().toLowerCase()) >= 0){
        meunsAct=index;
      }
      // if(menus.Url.trim().toLowerCase()===url.replace('/tabs/','').trim().toLowerCase()){
      //   meunsAct=index;
      // }
      });
    return meunsAct;
  }

  /**
   * 过滤url地址
   * @param url 
   */
  public replaceMenusUrl(url:any){
    let _url:any = undefined;
    if(url){
      _url = url.replace('/tabs/','');
    }
   return _url;
  }
  /**
   * 对比一级菜单url地址
   * @param url url地址
   */
  public getMenusUrl(url:string=""):boolean{
    // ////console.log(url);
     const that=this;
     let meunsUrl:boolean=false;
     if(url == "/login"){
      meunsUrl=true;
     }else{
      //获取一级菜单的url地址
      that.GetMenus.forEach((menus)=>{
        if(menus.Url.trim().toLowerCase()===url.replace('/tabs/','').trim().toLowerCase() && menus.IsHome && menus.IsMainMenu){
            meunsUrl=true;
        }
        });
     }
   return meunsUrl;
  }
  /**
   * 登录时获取有二级菜单的数据数据
   */
  public get getHomeMenus():Array<SysMenus>{
    let sb:Array<SysMenus> = new Array<SysMenus>();
    const that=this;
    that.GetMenus.forEach((menus)=>{
      if( typeof(menus.menus)!="undefined" || !menus.IsHome)
      {
        sb.push(menus);
      }
      });
      return sb;
  }
  /**
   * 获取首页展示菜单,只能一个
   */
  public getHonmeUrl():SysMenus{
    // ////console.log(1001011);
    let sb:SysMenus = new SysMenus();
    const that=this;
    that.GetMenus.forEach((menus)=>{
      if( menus.IsHome && menus.IsMainMenu)
      {
        sb = menus;
      }
      });
      return sb;
  }
  /**
   * 退出程序
   */
 public exitApp():void{
    let that=this;
    that.msg.Confirm("确定退出应用程序？").then(data=>{
      if(data){
        navigator['app'].exitApp();
      }
    });
  }
  /**
   * 获取菜单节点
   */
  get GetMenus():Array<AppMenus>{
    let appMenus:Array<AppMenus>= new Array<AppMenus>();
    let Menus=this.GetStorageKey("menus");
    if(Menus){
      appMenus=Menus;
    }
    return appMenus;
  }
  /**
   * 第一次登录时页面配置文件存入全部存入
   * @param data 返回的页面数据格式，并且缓存当前文件的时间戳
   */
  SetAllPageConfig(data:any){
    if(data){
    let pages=data.pages||data.Pages;
    let stamp=data.stamp||data.Stamp;
      if(pages.length>0){
      //   const localtime=this.GetStorageKey("pageConfigTime");
      //   const time=stamp;
      //   if(time && localtime){
      //     if(time.toString()===localtime.toString()){
      //     return;
      //     }
      // }
      
      localStorage.setItem("pageConfig",JSON.stringify(pages)|| null);//缓存所有页面数据
      localStorage.setItem("pageConfigTime",stamp|| null);//缓存当前页面时间戳
      if(this.platform.is("cordova")){
       //#region  保存缓存文件到手机安装目录中，卸载程序则自动删除 
       try{
        this.WriteExistingFile(JSON.stringify(pages)).then(result=>{
          console.log(result);
        }).catch(error=>{
          console.log(error,"第一次登录时页面配置");
        });
      }catch(err){
        console.log(err,"第一次登录时页面配置 try");
      }
    //#endregion
      }
    }
  }
}
  /**
   * 获取页面数据节点
   */
  get GetAllPageConfig():Array<AppPageConfig>{
    let appwebPage:Array<AppPageConfig>= new Array<AppPageConfig>();
    let appweb=this.GetStorageKey("pageConfig");
    if(appweb){
      appwebPage=appweb;
    }
    return appwebPage;
  }
    /**
   * 过滤掉页面模块/字段权限数据节点
   */
  private GetFieldPageConfig(key:string):Data{
    let appwebPage:Data=null;
    let appweb=this.GetStorageKey("pagemode");//模块权限过滤
    if(appweb){
      let appfieldpersion=appweb[key];
      if(appfieldpersion){
        let searchList=appfieldpersion;
        if(searchList){
          appwebPage=searchList;
        }
      }
      
    }
    return appwebPage;
  }
  /**
   * 获取对应的页面配置列表文件
   * @param Key 表示当前页面的名称，类似于后端对应的xml的ConfigName值。
   * @param isfieldpersion:表示是否权限过滤的数据源，默认所有数据false
   */
  GetPageConfigKey(Key:string,isfieldpersion:boolean=false):Data{
   ////console.log(1001011);
    let allpageConfigweb:Data=null;
       let pageList:Array<AppPageConfig>=null;
        pageList=this.GetAllPageConfig;
        pageList.forEach((items,keyindex)=>{
          if(items.Key){
            if(items.Key.toLowerCase()===Key.toLowerCase()){
              if(items.Data){
                allpageConfigweb=items.Data;
                allpageConfigweb=this.PageModalOrPermission(items.Data,Key);
              }
            }
          }
        });
        // let list=pageList.find((items)=>items.Key ===Key);
        // if(list){
        //   let AllList=pageList.find((items)=>items.Key===Key).Data;
        //   if(AllList){
        //     allpageConfigweb=AllList;
        //     allpageConfigweb=this.PageModalOrPermission(AllList,Key);
        //   }
        // }
       return allpageConfigweb;
  }
  /**
   * 
   * @param data 存储临时数据
   */
  SetTempPageMode(data:any){
     let pageconfigmodel=JSON.parse(localStorage.getItem("temppagemode"));
     if(pageconfigmodel){
     }else{
       localStorage.setItem("temppagemode",JSON.stringify(data));
     }
  }
  /**
   * 获取临时
   * @param configName 获取当前xml名称
   */
  GetTempPageModeKey(configName:string){
    let data = null;
    let pagemodel=JSON.parse(localStorage.getItem("temppagemode"));
    if(pagemodel){
      data = pagemodel;
    }
    return data;
  }
  /**
   * PG信息数据
   */
  get getPGInfo(){
    let pginfo = this.GetStorageKey("pginfo");
    if(pginfo){
      return pginfo;
    }else{
      return {};
    }
  }
  /**
   * 获取token值
   */
  get getToken():Token{
    let apptoken:Token;
    let apptokeninfo=localStorage.getItem("token");
    if(apptokeninfo){
      apptoken=JSON.parse(apptokeninfo);
    }
    return apptoken;
  }
  /**
   * 判断角标是否完成，返回bool类型；默认 true
   * @param pangeName 当前页面的pagename;
   */
  getBadge(pangeName:any){
    const that = this;
    let isbadge:boolean=true;
    //先判断是否必填/或者设置上班可操作时有效
    let homeArray:Array<any> = that.GetStorageKey("badge_"+that.GetAccount.Id);
    //console.log(homeArray);
    const PageName = pangeName;
    if(homeArray){
    const newArraYList:any=homeArray.find(items=>items.pageName.trim().toLowerCase()==PageName.trim().toLowerCase());
    if(newArraYList){
      newArraYList.temps.forEach(temp=>{
        temp.btns.forEach(btn=>{
          if(btn.employLimit=="work"){
            if(btn.required && !btn.state){
              isbadge=false;
            }
          }else{
            if(btn.required && !btn.state){
              isbadge=false;
            }
            
          }
          // if((btn.required && !btn.state)||(btn.employLimit=="work")){
          //   isbadge=false;
          // }
        });
     });
    }
   
  }
  return isbadge;
}
/**
 * 更改角标数据，完成/未完成及时更新
 * @param pageName 当前页面的pageName
 * @param btnName 更改的按钮Name
 */
setBadge(pageName:any,templateName:any,btnName:any){
  const that = this;
   //先判断是否必填项未完成
  //  ////console.log(1101);
   let badgeArray:Array<any> = that.GetStorageKey("badge_"+that.GetAccount.Id);
   if(badgeArray){
    const addArraYList:any=badgeArray.find(items=>items.pageName.trim().toLowerCase()==pageName.trim().toLowerCase());
    if(addArraYList){
       let addList:any=addArraYList.temps.find(titem=>titem.tempName.trim().toLowerCase()==templateName.trim().toLowerCase());
       if(addList){
        addList.btns.forEach(btn=>{
          if(btn.btnName.trim().toLowerCase()==btnName.trim().toLowerCase()){
              btn.state+=1;
          }
        });
       }
    }
   }
   localStorage.setItem("badge_"+that.GetAccount.Id,JSON.stringify(badgeArray));
// //console.log(badgeArray);
}
  /**
   * 获取浏览器名称
   */
  get BrowserRedirect():string{
    let mobileType="";
    let sUserAgent = navigator.userAgent.toLowerCase();
    let bIsIpad = sUserAgent.match(/ipad/i);
    let bIsIphoneOs = sUserAgent.match(/iphone os/i);
    let bIsMidp = sUserAgent.match(/midp/i);
    let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i);
    let bIsUc = sUserAgent.match(/ucweb/i);
    let bIsAndroid = sUserAgent.match(/android/i);
    let bIsCE = sUserAgent.match(/windows ce/i);
    let bIsWM = sUserAgent.match(/windows mobile/i);
    let weixin=sUserAgent.match(/MicroMessenger/i);//微信
    if (bIsIpad || bIsIphoneOs) {
        mobileType="maxos";
    }else if(weixin){
      mobileType="weixin";
    } 
    else {
        mobileType="pc";
    }
    return mobileType;
  }
  /**
   * 返回上一个页面
   * @param isRefresh 是否刷新上一个页面，默认刷新,default:true
   */
  goBack(isRefresh:boolean=true){
    const that =this;
    console.log("backlouut.....");
    let arrayList:Array<any>=[];
    let urltemp:any ="";
    if(localStorage.getItem("backurl")){
      arrayList = that.GetStorageKey("backurl")||[];// JSON.parse(localStorage.getItem("backurl"));
      if(arrayList.length>0){
            urltemp= arrayList[arrayList.length-1];
            if(urltemp.indexOf('[Refresh]')>=0){//表示是不刷新页面则主动设置isRefresh为false
              isRefresh = false;
            }
            urltemp=urltemp.replace("[Refresh]","");
            arrayList.splice(arrayList.length-1,1);
            localStorage.setItem("backurl",JSON.stringify(arrayList));
            if(isRefresh){//如果刷新页面,添加时间戳
              if(urltemp.split('/').length==4){
                // if(that.getFirstMenuUrl(urltemp)){//如果configName则
                //   that.router.navigate([urltemp]);
                // }else{
                //   that.router.navigate([urltemp+'/'+that.getNowDatetime]);
                // }
                that.router.navigate([urltemp]);
                
              }else if(urltemp.split('/').length==5){
                that.router.navigate([urltemp+'/'+that.getNowDatetime]);
              }else{
                if(urltemp.indexOf('&')=="-1"){
                  if(urltemp.indexOf("/tabs/home")!=-1)
                  {
                    that.router.navigate(["/tabs/home/"]);
                  }
                  else{
                    that.router.navigate([urltemp+'&'+that.getNowDatetime]);
                  }
                }else{
                  that.router.navigate([urltemp+that.getNowDatetime]);
                }
                
              }
            }else{
              that.router.navigate([urltemp]);
            }
   
      }else{
        that.navctr.pop();
      }
   
    }else{
      that.navctr.pop();
    }

  }
  /**
   * 移除返回
   */
  removeBack(){
    let arrayback:Array<any> = [];
    if(localStorage.getItem("backurl")){
      arrayback = this.GetStorageKey("backurl")||[];
      if(arrayback.length>1){//判断缓存几个url地址
         arrayback.splice(arrayback.length-1,1);
      }
      localStorage.setItem("backurl",JSON.stringify(arrayback));
    }
  }
   /**
   * 获取当前页面地址
   * @param isRefresh 存取地址时，判断是否返回时刷新当前页面,默认为"true"刷新
   */
  setHistoryUrl(isRefresh:boolean=true){
    let that = this;
    let locationback:Array<any>=[];
    if(localStorage.getItem("backurl")){
       locationback = that.GetStorageKey("backurl")||[];//    JSON.parse(localStorage.getItem("backurl"));
    }
    //console.log("地址对比");
    if(that.platformlocation["location"].hash.replace('#','')){
      const backurl:any =that.platformlocation["location"].hash.replace('#','');
      const newurl:any = locationback[locationback.length-1];
      let historyUrl=that.platformlocation["location"].hash.replace('#','');
      if(!isRefresh){//刷新时处理
        historyUrl=historyUrl+"[Refresh]";
      }
      if(newurl && backurl){
        if(newurl.indexOf('&')!="-1" && backurl.indexOf('&')!="-1"){//表示有时间戳
          const _strurl=newurl.substring(0,newurl.lastIndexOf('/'));
          const _newurl=backurl.substring(0,backurl.lastIndexOf('/'));
          if(_strurl!=_newurl){
            locationback.push(historyUrl);
          }
        }else{
          locationback.push(historyUrl);
        }
      }else{
        locationback.push(historyUrl);
      }
    }
    
    localStorage.setItem("backurl",JSON.stringify(locationback));
  
  }
  /**
   * 坐标距离计算
   * @param lng  开始纵坐标
   * @param lat 开始横坐标
   * @param endlng 结束纵坐标
   * @param endlat 结束横坐标
   */
  Dist(lng, lat, endlng, endlat):any 
  {
    console.log("坐标计算");
        if (lng > 0 && lat > 0 && endlng > 0 && endlat > 0) {
          let sqlnumber:number = 6378137 * 2 * Math.asin(
            Math.sqrt(
                Math.pow(Math.sin((lat - endlat) * Math.acos(-1) / 360), 2)
                + Math.cos(lat * Math.acos(-1) / 180)
                * Math.cos(endlat * Math.acos(-1) / 180)
                * Math.pow(Math.sin((lng - endlng) * Math.acos(-1) / 360), 2)
            )
        );
          if(sqlnumber < 0){
            sqlnumber = 0;
          }
          return sqlnumber;
        }
        else {
            return 0;
        }
      
  }
  /**
   * 判断是否正整数
   * @param str 需要输入的值
   */
  isNumber(str:any){
    const code = /^\+?[1-9][0-9]*$/;
    // //console.log(code.test(str));
    return code.test(str);
  }
     /**
   * 验证是否正整数，并且返回数字，或者null
   * @param str 需要输入的值
   */
  GetNumber(str:any){
    const code = new RegExp("^[0-9]*$");
    const maxNum:number =Number.parseInt(app.NUM);
    let codeNum:number=0;
    // console.log(str);
    if(code.test(str)){
          codeNum=Number.parseInt(str);
      let strnum = codeNum;
      if(codeNum>maxNum){
        let maxlength:number =maxNum.toString().length; 
        codeNum = Number.parseInt(strnum.toString().substring(0,maxlength));
      }
      return codeNum;
    }else{
      return null;
    }
  }
  /**
   * 判断小数点后两位小数
   * @param str  需要输入的值
   */
  isDouble(str:any){
    const code =/^(([1-9][0-9])|(([0].\d{0,2}|[1-9][0-9].\d{0,2})))$/;
    // console.log(code.test(str));
    return code.test(str);
  }
  /**
   * 匹配小数
   */
  decimal(value:string){
      value = value.toString();
    let textvalue=value.match(/[0-9]\d*.\d*|0.\d*[0-9]\d*|[0-9]/);
    let zzs=/^[0-9]\d*$/;
    let indexvalue:any;
    let result:any = null;
    if(textvalue){
      if(textvalue[0].indexOf(".")>=0){
        indexvalue=textvalue[0];
       let splitText=indexvalue.toString().split(".");
       if(zzs.test(splitText[0])){
        if(splitText[1].length>=2){
          result = splitText[0]+"."+splitText[1].toString().substring(0,2);
        }else{
          result = splitText[0]+"."+splitText[1];
        }
       }
      }else{
        if(zzs.test(textvalue[0])){
          result=textvalue[0];
        }
      }
    }
    //  //console.log(result);
   return result;
  }
  
  /**
  *年份数组
  */
  get GetYearArr () {
    let now = new Date();
    let nowYear = now.getFullYear();
      var arr = [];
      for (var i = nowYear - 10; i <= nowYear + 10; i++) {
          arr.push(i);
      }
      return arr;
  }

  /**
   * 格式化年份
   * @param nowYear 
   */
  get FormatYear () {
  let now = new Date();
  let nowYear = now.getFullYear();
    var arr = [];
    for (var i = nowYear - 5; i <= nowYear + 10; i++) {
        arr.push({
            id: i + '',
            value: i + '年'
        });
    }
    return arr;
} 
/**
 * 格式化月份
 */
get FormatMonth () {
  var arr = [];
  for (var i = 1; i <= 12; i++) {
      arr.push({
          id: i + '',
          value: i + '月'
      });
  }
  return arr;
}
/**
 * 格式化天数
 * @param count 
 */
FormatDate (count) {
  var arr = [];
  for (var i = 1; i <= count; i++) {
      arr.push({
          id: i + '',
          value: i + '日'
      });
  }
  return arr;
}
FormatDateData(type:any,data:string=""){
  let timeDate:Array<any>=new Array<any>();
  let resultData:Array<any> = new Array<any>();
  if(data.indexOf("-")>=0){
    timeDate = data.split("-");
  }else if(data.indexOf("/")>=0){
    timeDate = data.split("/");
  }else if(data.indexOf(":")>=0){
    timeDate = data.split(":");
  }
  switch(type){
    case "yyyymmdd"://年月日
    timeDate.forEach(item=>{
      if(item.indexOf(":")>=0){
        if(item.split(" ")[0]){
          resultData.push(Number.parseInt(item.split(" ")[0]));
        }
      }else{
        if(item){
          resultData.push(Number.parseInt(item));
        }
      }
    });
  break;
  case "yyyymm"://年月
  timeDate.forEach(item=>{
    if(item.indexOf(":").length<0){
      resultData.push(Number.parseInt(item));
    }
  });
  break;
  case "hhmmss"://时分秒
  timeDate.forEach(item=>{
    if(item.indexOf(":")>=0){
      let temparray:any;
      if(item.split(" ").length>0){
        temparray = item.split(" ")[1];
        temparray.split(":").forEach(temp=>{
          resultData.push(Number.parseInt(temp));
        });
      }
    }else{
      resultData.push(Number.parseInt(item));
    }
  });
    break;
    case "hhmm"://时分
    ////console.log(timeDate);
    timeDate.forEach(item=>{
      if(item.indexOf(":")>=0){
        let temparray:any;
        if(item.split(" ").length>0){
          temparray = item.split(" ")[1];
          let hhtemp = temparray.split(":");
          for(let i=0; i<hhtemp.length-1;i++){
            resultData.push(Number.parseInt(hhtemp[i]));
          }
        }
      }else{
        resultData.push(Number.parseInt(item));
      }
    });
    break;
    case "default"://时分
    case "yyyymmddhhmmss"://时分
    timeDate.forEach(item=>{
      if(item.indexOf(":")>=0){
        let temparray:any;
        if(item.split(" ").length>0){
          resultData.push(item.split(" ")[0]);
          temparray = item.split(" ")[1];
          temparray.split(":").forEach(temp=>{
            resultData.push(Number.parseInt(temp));
          });
        }
      }else{
        resultData.push(Number.parseInt(item));
      }
    });
    break;
  }
  return resultData;
}

/**
 * 计算小时
 * @param one 
 * @param two 
 * @param three 
 */
get GetHourData(){
  var hours = [];
  for (var i = 0,len = 24; i < len; i++) {
      hours.push({
          id: i,
          value: i + '时'
      });
  }
  return hours;
}
/**
 * 计算分
 * @param one 
 * @param two 
 * @param three 
 * @param four 
 */
get GetMinuteData(){
  var minutes = [];
  for (var i = 0, len = 60; i < len; i++) 
  {
      minutes.push({
          id: i,
          value: i + '分'
      });
  }
  return minutes;
}  
/**
 * 计算秒
 */
get GetSecondsData(){
  var seconds = [];
  for (var i = 0, len = 60; i < len; i++) {
      seconds.push({
          id: i,
          value: i + '秒'
      });
  }
  return seconds;
 } 
 /**
  * 判断当前手机系统版本是否小于5.0
  */
 get Isandroidversion(){
  const that =this;
  let isplatform:boolean = false;
  if(that.platform.is("cordova")){
    if(that.platform.is("android")){
      if(that.device.version){
        // if(that.device.version.toString().startsWith("5")){
        //   isplatform=true;
        // }else 
        if(that.device.version.toString().startsWith("4")){
          isplatform=true;
        }else if(that.device.version.toString().startsWith("3")){
          isplatform=true;
        }else if(that.device.version.toString().startsWith("2")){
          isplatform=true;
        }
      }
     }
  }
  return isplatform;
 }
 /**
  * debug 输出模式
  * @param message 文本内容
  */
 Log(message:any){
   if(app.DEBUG){
     //console.log(message);
   }
 }
  getGradeCode(code:string){
    if(!code){
      return 0;
    }
    switch(code){
      case "D000":
        return 0;
      case "D001":
        return 1;
      case "D002":
        return 2;
      case "D003":
        return 3;
      default:
        return 0;
    }
  }
  /**
 * 初始化项目数据
 */
initLoad(fileName:any = "GMI.json"):Promise<any>{
  const that =this;
    return  new Promise<any>((resolve,reject)=>{
      //判断当前是否真机
        let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
        if(that.platform.is("android")){
          tempDirectory=that.file.externalCacheDirectory;//android
        }
          try{
              //判断手机目录是否存在数据库文件,存在的话直接输出
              that.file.readAsText(tempDirectory,fileName).then(a2Data=>{
                console.log("文件存在");
                // if(JSON.parse(a2Data)){
                //   let body = JSON.parse(a2Data);
                //   that.SetAllPageConfig(body);
                // }
                resolve(a2Data);
              }).catch(err=>{
                console.log("文件不存在");
                console.log(that.file.applicationDirectory);
                console.log(that.file.applicationStorageDirectory);
              let fileUrl=that.file.applicationDirectory+"www/assets";//"file:///android_asset/www/assets
              //不存在,拉取app程序本地文件
              that.file.readAsText(fileUrl,"All.json").then(all=>{
                console.log("读取文件成功");
                    let alljson =JSON.parse(all);
                    // that.SetAllPageConfig(alljson);
                    that.file.writeFile(tempDirectory,fileName,JSON.stringify(alljson),{replace:true}).then(data=>{
                      console.log("写入文件成功");
                        console.log(data);
                    }).catch(err=>{
                      console.log("写入文件失败");
                        console.log(err);
                    });
                    resolve(all);
                }).catch(err=>{
                  console.log("读取文件失败");
                    console.log(err);
                    reject(err);
                });
              });
          }catch(err){
            console.log("try");
            reject(err);
          }
    });
}
  /**
 * 保存文件到手机临时目录,默认保存在 externalCacheDirectory目录
 * @param stringContent 需要保存的数据对象，必须是string类型数据，否则保存失败
 * @param fileName 需要保存的文件名称以及类型,默认"a2.json"
 */
WriteFile(stringContent:any,fileName:any="GMI.json"):Promise<any>{
  const that=this;
  return new Promise<any>((resolve,reject)=>{
    //判断当前是否真机
    if(that.platform.is("cordova")){
      let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
      console.log(tempDirectory);
      if(that.platform.is("android")){
        tempDirectory=that.file.externalCacheDirectory;//android
      }
      try{
           console.log("保存文件之前","单文件");
           that.file.writeFile(tempDirectory,fileName,stringContent,{replace:true}).then(data=>{
            console.log(data);
            resolve(data);
          }).catch(err=>{
              console.log(err);
              reject(err);
          });
      }catch(err){
        reject(err);
      }
    }else{
      reject("非真机环境");
    }
  });
}
/**
 * 保存文件到手机临时目录,如果文件存在则合并数据；默认保存在 externalCacheDirectory目录
 * @param stringContent 需要保存的数据对象，必须是string类型数据，否则保存失败
 * @param fileName 需要保存的文件名称以及类型,默认"a2.json"
 */
WriteExistingFile(stringContent:any,fileName:any="GMI.json"){
  const that=this;
  return new Promise<any>((resolve,reject)=>{
    //判断当前是否真机
    if(that.platform.is("cordova")){
      let tempDirectory:any=that.file.tempDirectory;//默认ios临时目录
      if(that.platform.is("android")){
        tempDirectory=that.file.externalCacheDirectory;//android
      }
      try{
           console.log("保存文件之前","多文件");
          that.file.readAsText(tempDirectory,fileName).then(fileData=>{//P判断当前文件是否存在,并判断时候有值
            let tempobj:Array<any> = new Array<any>();
            let arrayobj:any=JSON.parse(fileData);
            if(arrayobj.constructor==Array){
              tempobj = arrayobj;
            }else{
              tempobj.push(arrayobj);
            }
            let temp = JSON.parse(stringContent);
                 tempobj.push(temp);
            that.WriteFile(JSON.stringify(tempobj),fileName).then(data=>{
              console.log(data);
              resolve(data);
            }).catch(err=>{
                console.log(err);
                reject(err);
            });
          }).catch(err=>{
            that.WriteFile(stringContent,fileName).then(data=>{
              console.log(data);
              resolve(data);
            }).catch(err=>{
                console.log(err);
                reject(err);
            });
          });
      }catch(err){
        reject(err);
      }
    }else{
      reject("非真机环境");
    }
  });
}
  /**
 * 获取指定文件夹下所有的文件以及目录
 * @param path 手机上真实的目录地址
 * @param dirName 文件或者目录名称
 */
GeAllFieldsList(path:string="",dirName:string=""):Promise<any>{
  const that =this;
  return new Promise<any>((resolve,reject)=>{
   //判断当前是否真机
   if(that.platform.is("cordova")){
      path=that.file.tempDirectory;//默认ios临时目录
    if(that.platform.is("android")){
      path=that.file.externalCacheDirectory;//android
    }
     that.file.listDir(path,dirName).then(data=>{
      resolve(data);
       console.log(data);
     }).catch(err=>{
      reject(err);
      console.log(err);
     });
   }else{
    reject("必须真机测试");
   }
  });
}

/**
 * 计算localStorage剩余大小(kb)
 */
getStorageSize(){
  var size = 0;
  for(let item in window.localStorage) {
      if(window.localStorage.hasOwnProperty(item)) {
          size += window.localStorage.getItem(item).length;
      }
    }
    return (size / 1024).toFixed(2) + 'KB';
  }
/**
 * 获取缓存中需要的配置项
 */
GetStaticObject(){
  let data:Array<any> = this.GetStorageKey("StaOb") || [];
  if(data){
    data.forEach((e,index)=>{
        if(e.a_Code){
          if(e.a_Code=="WEBSITE"){//处理所有常量关联域名问题处理
                 if(localStorage.getItem("WEBSITE")){
                  e.a_Value=localStorage.getItem("WEBSITE");
                 }
            this.getWebSetApp("WEBSITE",e.a_Value);
         }else if(e.Code=="WEBURL"){
             this.getWebSetApp("WEBURL",e.a_Value);
         }else{
              app[e.a_Code]=e.a_Value;
          }
      }
    });
  }
}
/**
   * 测试切换时域名切换回来问题
   */
  getAppsetting(){
    const that =this;
  if(!that.GetStorageKey("StaOb")){
      that.loadScript("assets/appsettings.js",function(load){console.log(load)});
      return;
    }else{
      let arrayListNew:Array<any> = that.GetStorageKey("StaOb");
      arrayListNew.forEach((El,index)=>{
          if(El.a_Code=="WEBSITE" && El.a_Value){
              that.getWebSetApp("WEBSITE",El.a_Value);
          //   app.WEBSITE=El.a_Value;
          }
      });
    }
}
/**
 * 更具后端配置切换本地配置文件数据
 */
getAppConfig(appArray:Array<any>=[]){
      appArray.forEach((e,index)=>{
          if(e.a_Code){
              if(e.a_Code=="WEBSITE"){//处理所有常量关联域名问题处理
                 this.getWebSetApp("WEBSITE",e.a_Value);
              }else if(e.a_Code=="WEBURL"){
                  this.getWebSetApp("WEBURL",e.a_Value);
              }
              else{
                  app[e.a_Code]=e.a_Value;
              }
          }
  });
}
/**
 * 修改域名多处使用地方处理
 * @param appName 当前域名的key
 * @param value 对应的value值
 */
getWebSetApp(appName:string,value:string){
  let app_value = app[appName];
  for(let key  in app){
    if(key=="WEBSITE" || key=="WEBURL"){

    }else{
    if(typeof(app[key])=="string")
    {
        if(app[key]){
            if(key!=appName){
                app[key]=app[key].replace(app_value,value);
            }
        }
    }
  }
    // console.log(key + '---' + app[key]);          
  }
app[appName]=value;
}
    /**
     * 动态加载js文件
     * @param src  文件路劲
     * @param callback 返回值
     */
    loadScript(src, callback) {
      let script = document.createElement('script'),
        head = document.getElementsByTagName('head')[0];
      script.type = 'text/javascript';
      script.charset = 'UTF-8';
      script.src = src;
      if (script.addEventListener)
      {
        script.addEventListener('load', function () {
          callback();
        }, false);
      }
      head.appendChild(script);
    }
      /**
   * 移除本地缓存数据,根据对应的key删除
   * @param item localStorage对应的key值，可以传多个,["key1","key2"...]
   */
  removeItem(item:Array<string>=[]){
    item.forEach(its=>{
       localStorage.removeItem(its);
    });

  }
  /**
   * 处理必填项是否已填写
   * @param configName 对应当前的xml名称
   */
  IsConverMarking(configName:string):boolean{
    const that =this;
    let  resultBoole:boolean = true;
    if(that.GetStorageKey("corner_"+configName)){
         let ele_list = that.GetStorageKey("corner_"+configName);
         console.log("角标");
         if(ele_list.temps.length>0){
          ele_list.temps.forEach(temp=>{
            temp.btns.forEach(btn=>{
              if(btn.required && btn.state<=0){//如果 必填并且 数量为小于零的结果则提示有必填项
                resultBoole = false;
              }
            });
          });
         }
    }
    return resultBoole;
  }

   /**
     * 遍历数组数据获取当前页面权限数据对象以及整个框架结果数据
     * @param data 
     */
    JurisdictionArrayList(data:any,xmlconfigName:string):Array<any>{
      console.log(data,"数据");
      let bw:Array<any> = new Array<any>();
      let juest:any={"xml":null,"all":[]};
      data.forEach(el=>{
        if(el["Key"]==xmlconfigName){
          juest.xml = this.GetPageConfigData(el,xmlconfigName);
         }
      });
     juest.all=data;
      return juest;
    }
      /**
   * 获取对应的页面配置列表文件
   * @param page 表示当前页面配置。
   * @param key 表示当前页面configName。
   */
  GetPageConfigData(page:any,Key:string):Data{
    //console.log(1001011);
     let allpageConfigweb:Data=null;
     if(page.Data){
      allpageConfigweb=page.Data;
      allpageConfigweb=this.PageModalOrPermission(page.Data,Key);
    }
   return allpageConfigweb;
   }
       /**
    * 去除特殊字符
    * @param str 
    */
   GetChineselanage(str:string=""){
    if(!str){
     str="";
    }
   let ar:Array<string> = app.Special.split(',');
   ar.forEach(chart=>{
     str=str.replace(new RegExp(chart,'g'),"");
   });
   return str;
  }
  /**
   * 获取GUID,app端返回的是数据库对应的guid,例如:'1212f4f6-8d91-4534-a20c-87aed2c3c90f',网页端返回的是时间格式;例如:'201911041211455'
   */
  GUID():Promise<string>{
    const that =this;
    return new Promise<string>((reject,resolve)=>{
      let getNowDate:string = that.getNowDatetime;
      console.log(getNowDate);
     if(that.platform.is("cordova")){
     try{
       cordova.plugins.camera.GUID("get GUID",function(data){
         reject(data);
       },function(err){
         reject(getNowDate);
       });
     }catch(err){
       reject(getNowDate);
     }
     }else{
       reject(getNowDate);
     }
    });
  }
       /**
    * 文件类型 默认为:".pdf"
    * @param key 当前文件的后缀名称，默认:".pdf"
    */
   ContentType(key:string=".pdf"){
     const that = this;
      let contentType:any={
        ".mp4":"video/mp4",
        ".wmv":"video/x-ms-wmv",
        ".pdf":"application/pdf",
        ".xml":"application/xml",
        ".zip":"application/zip",
        ".ppt":"application/x-ppt"
      };
      console.log(".pdf","文件类型");
      /**
       * 获取后端返回的配置文件
       */
      if(app["MIME"]){
        contentType = Object.assign(contentType,app["MIME"]);
      }
     let defaultobj:any = that.GetStorageKey("StaOb");
     if(defaultobj){
       if(defaultobj["MIME"]){
            app["MIME"]=defaultobj["MIME"];
         contentType = Object.assign(contentType,defaultobj["MIME"]);
       }
     }
     let fileType:any="application/pdf";
         fileType=contentType[key];
     return fileType;
   }

    /**
  * 判断微信是否支持
  */
    get IsWeixinBrowser() {
        var ua = navigator.userAgent.toLowerCase();
        var result = (/micromessenger/.test(ua)) ? true : false;
        if (result) {
            console.log('你正在访问微信浏览器');
        }
        else {
            console.log('你访问的不是微信浏览器');
        }
        return result;
    }
    /**
     * 判断是否来自微信浏览器并且是android；
     */
    get isWeixinAndroid() {
        if (this.IsWeixinBrowser) {
            if (/android/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    /**
     * 判断是否来自微信浏览器并且是IOS；
     */
    get isWeixinIOS() {
        if (this.IsWeixinBrowser) {
            if (/ipad|iphone|mac/i.test(navigator.userAgent)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    
  /**
   * 获取当前url所带参数
   */
  GetQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let searchArr = window.location.href.split("?");
    let search = "";
    if(searchArr.length > 1){
        search = searchArr[1];
    }
    var r = search.match(reg);
    if (r != null) return decodeURIComponent(r[2]); return null;
  }

  /**
 * 微信请求接口配置,调用微信wx.config方法
 */
WXConfig():Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
    let  wxfg:any = that.GetStorageKey("wxconfig");
    if(wxfg){
     let _newwxconfig = that.base.WxConfig;
          //  wxfg.config.debug=app.DEBUG;//是否关闭debug模式
           wxfg.config.debug=false;//是否关闭debug模式
     let _wxconfig:any =Object.assign(_newwxconfig,wxfg.config);
     msg.ResponseMessage.Success=true;
     try{
      wx.config(_wxconfig);
      wx.ready(function(e){
        console.log(e,"ready");
        setTimeout(()=>{
         resolve(msg);
        },600);
       });
       wx.error(function(res){
         msg.ResponseMessage.Success=false;
         msg.ResponseMessage.ErrorCode=63002;
         msg.ResponseMessage.ErrorMessage=JSON.stringify(res);
         console.log(res.errMsg,"微信失败");
         if(res.errMsg.indexOf("config:fail")!=-1){
          msg.ResponseMessage.ErrorMessage=JSON.stringify(res);//"微信授权失败，请联系管理员";
         }
          reject(msg);
       });
     }catch(err){
      msg.ResponseMessage.Success=false;
      msg.ResponseMessage.ErrorCode=63002;
      msg.ResponseMessage.ErrorMessage=err;
       reject(msg);
     }
    }else{
      msg.ResponseMessage.Success=false;
      reject(msg);
    }
  });
}
/**
 * 
 * @param corpid 必填，企业微信的corpid，必须与当前登录的企业一致
 * @param agentid 必填，企业微信的应用id
 * @param timestamp 必填，生成签名的时间戳
 * @param nonceStr 必填，生成签名的随机串
 * @param signature 必填，签名
 * @param jsApiList 必填，权限列表
 */
AgentConfig(corpid:string,agentid:string,timestamp:number,nonceStr:string,signature:string,jsApiList:Array<string>=[]):Promise<WebResponesContext>{
  const that=this;
  return new Promise<WebResponesContext>((resolve,reject)=>{
    let msg:WebResponesContext=new WebResponesContext();
     msg.ResponseMessage.Success=true;
     console.log("授权开始");
     wx.agentConfig({
      corpid: corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
      agentid: agentid, // 必填，企业微信的应用id
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature,// 必填，签名，见附录1
      jsApiList: jsApiList, //必填
      success: function(res) {
          // 回调
          console.log(res,"successresult");
          console.log("agentConfig，success回调成功");
          resolve(msg);
      },
      fail: function(res) {
        console.log(res,"fail");
          if(res.errMsg.indexOf('function not exist') > -1){
            res.errMsg="版本过低请升级";
          }
          msg.ResponseMessage.Success=false;
          msg.ResponseMessage.ErrorCode=63002;
          msg.ResponseMessage.ErrorMessage=JSON.stringify(res);
           console.log(res,"微信失败");
           reject(msg);
      }
      });
  });

}
/**
 * 授权登录
 * @param params 授权参数
 */
AgentConfigWechat(params: AgentConfigParams): Promise<WebResponesContext> {
  const that = this;
  let isagent:boolean=false;//判断是否权限无法认证。
  return new Promise<WebResponesContext>((resolve, reject) => {
    let msg: WebResponesContext = new WebResponesContext();
    msg.ResponseMessage.Success = true;
    wx.agentConfig({
      corpid: params.Corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
      agentid: params.Agentid, // 必填，企业微信的应用id
      timestamp: params.Timestamp, // 必填，生成签名的时间戳
      nonceStr: params.NonceStr, // 必填，生成签名的随机串
      signature: params.Signature,// 必填，签名，见附录1
      jsApiList: params.JsApiList, //必填
      success: function (res) {
        isagent=true;
        // 回调
        console.log("agentConfig，success回调成功");
        resolve(msg);
      },
      fail: function (res) {
        isagent=true;
        if (res.errMsg.indexOf('function not exist') > -1) {
          res.errMsg = "版本过低请升级";
        }
        msg.ResponseMessage.Success = false;
        msg.ResponseMessage.ErrorCode = 63002;
        msg.ResponseMessage.ErrorMessage = JSON.stringify(res);
        console.log(res, "微信失败");
        reject(msg);
      }
    });
    let timeout=setTimeout(()=>{
      console.log(isagent,"授权timeout");
      if(isagent){
        clearTimeout(timeout);
      }else{
        resolve(msg);
      }
    },3000);
  });
}

  /**
    * 
    * @param _message 提示消息
    * @param _postion 展示位置,bottom,选择值为："top", "middle", "bottom".
    * @param isAutoClose 是否手动关闭提示框，默认自动关闭，默认关闭时间为3秒，及3000.
    * @param duration 自动关闭时间,默认为3000毫秒.
    */
   async Show(_message:string,_postion:string="bottom",isAutoClose:boolean=false,duration:number=300) {
    let option:any={
      message: _message,
      position: _postion,
      color:"dark"
    };
    //判断是否手动关闭
    if(isAutoClose){
      option["showCloseButton"]=true;
      option["closeButtonText"]="关闭";
    }else{
      option["duration"]=duration;
    }
    const toast = await this.toastController.create(option);
    toast.present();
  }

      /**
   * 
   * @param result 显示弹窗 品牌页面
   */
// async shougongAlertConfirm(list,item) {
  
  
//   const that = this;
//   // #region 
//   let _html= `<div><p class="c-no-margin"> ` ;
//   let _forHtml="";
//   let inv,preinv,sale,presale;
//   inv=item.SameMonthProductPSICount==1?"已填报":"未填报";
//   preinv=item.LastMonthProductPSICount==1?"已填报":"未填报";

//   sale=item.SameMonthProductSFTCount==1?"已填报":"未填报";
//   presale=item.LastMonthProductSFTCount==1?"已填报":"未填报";
//   _forHtml+=` <p class="c-no-margin" padding>  当月产品进销存：</span></p> `
//   _forHtml+=` <p class="c-no-margin"><span class=""> 上月`+preinv+`</span>/ `;
//   _forHtml+=` <span class=""> 当月`+inv+`</span>  </p> `;
//    let   store=that.GetStorageKey("tbstore");
//    if(store&&store["storeTypeCode"]=="T03")
//    {
//      _forHtml+=` <p class="c-no-margin" padding>  产品销售预估：</span></p> `
//      _forHtml+=` <p class="c-no-margin"><span class="">上月`+presale+`</span> /`;
//      _forHtml+=` <span class=""> 当月`+sale+`</span>  </p> `;
//     }
   
//   _html+=_forHtml;
//   _html+= '  </p>' + '</div>';
//   //#endregion
//   const alert = await this.alertCon.create({
//     header: '审核备注',
//     mode: "ios",
//     backdropDismiss:false,
//   //   message: 'Do you agree to use this lightsaber to do good across the galaxy?',
//   // message: _html,
//   //   cssClass: "s-brand",
//   cssClass: ``,//全局样式 s-brand 才生效
//   inputs: [
//     {
//       name: 'reason',
//       type: 'text',
//       placeholder: '请输入备注理由'
//     }
//   ],
//     buttons: [
//       {
//         text: "确认",
//         cssClass: 'btn-okay',
//         handler: (Okay) => {
//           //  that.savePost(item.status,Okay["reason"])
//           const that=this
//           return new  Promise((resolve,rejects)=>{
//           if(!Okay["reason"])
//           {
//             that.msg.Alert("请输入审核备注");
//             return
//           }
//           let reason=Okay["reason"]
//           let status=item.status
//           let body = new WebParameterContext()
        
//           // body.ConfigName = 'SystemApprovalRecords'
//           // let arr=that.baseService.ListData.filter(n=>n.isCheck).map(n=>n.a_ID)
//           let arr=list.filter(n=>n.isCheck).map(n=>n.a_ID)
//           if(arr.length<=0)
//           {
//             that.msg.Alert("请选择一条数据");
//             resolve("")
//             return
//           }
//           body.RequestBody=JSON.stringify({
//             ID:arr.join(","),
//             Remark:reason
//           })
//           let postUrl=app.AuditPost
//           if(status==1)
//           {
        
//           }else{
//             postUrl=app.RejectPost
//           }
//           let add=1
//           debugger
//           if(add==1)
//           {
//             return
//           }
//           that.http
//           .post(postUrl, body)
//           .then((data) => {
//             /****判断是否第一页begin****/
             
//             /****判断是否第一页end****/
//             if (data.ResponseMessage.Success) {
//               resolve(true)
//               console.log(data, 'deata')
//             }
//           })
//           .catch((error) => {
//             console.log(error)
//             rejects(null)
//             // that.apiObj['status'] = true
//             // that.apiObj['msg'] = ''
//             // that.loading = true
//           })
//             // if (Okay && Okay["checkCode"]) {
//             //     // that.CheckCode(Okay["checkCode"], webcontext);
//             // } else {
//             //     that.msg.Alert("收工原因不能为空！");
//             //    return;

//             // }
//           let objArray: Array<any> = [];
//     })

//         }
        
//       },
//       {
//         text: "取消",
//         role: 'cancel',
//         cssClass: 'secondary btn-cancel',
//         handler: (cancel) => {
//           //console.log(cancel,"cancel");
//         }

//       } 
//     ]
//   });
//   await alert.present();

 
// }
/**
 * 
 * @param str 金额千分位转换
 * @returns 
 */
 FormatMoney(str)
 {
    return   str.replace(/(\d{1,3})(?=(\d{3})+$)/g,function($1){ 
     return $1=$1+',' 
  })
 }
}




